import { EncryptYamatoBaggageResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { EncryptYamatoBaggageResultModel } from './encrypt-yamato-baggage-result.state';

/** StateDetailsActions */
const ACTION_SET = '[EncryptYamatoBaggageResult] set';
const ACTION_UPDATE = '[EncryptYamatoBaggageResult] update';
const ACTION_RESET = '[EncryptYamatoBaggageResult] reset';
const ACTION_FAIL = '[EncryptYamatoBaggageResult] fail';
const ACTION_CANCEL_REQUEST = '[EncryptYamatoBaggageResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[EncryptYamatoBaggageResult] set from api';
const ACTION_UPDATE_FROM_API = '[EncryptYamatoBaggageResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setEncryptYamatoBaggageResult = createAction(
  ACTION_SET,
  props<WithRequestId<EncryptYamatoBaggageResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateEncryptYamatoBaggageResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<EncryptYamatoBaggageResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetEncryptYamatoBaggageResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelEncryptYamatoBaggageResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failEncryptYamatoBaggageResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setEncryptYamatoBaggageResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<EncryptYamatoBaggageResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateEncryptYamatoBaggageResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<EncryptYamatoBaggageResponse>>()
);
